import buildDictionary from '@/common-utils/functions/buildDictionary';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SelectInput from '@/common-utils/components/ui/selectInput';


/**
 *
 * @param root0
 * @param root0.addFilter
 * @param root0.columnId
 * @param root0.defaultValue
 * @param root0.values
 * @param root0.resetThisFilter
 * @param root0.placeholder
 * @param root0.namespace
 * @param root0.setLaunchSearch
 * @param root0.sortOptions
 * @returns {JSX} SelectFilter
 */
function SelectFilter({
    addFilter,
    columnId,
    defaultValue,
    values,
    resetThisFilter,
    placeholder,
    namespace,
    setLaunchSearch,
    sortOptions = false
}) {
    const options = buildDictionary(values, 'entity', 'name');
    const [value, setValue] = useState(defaultValue ?? '');
    const [isDirty, setIsDirty] = useState(false);

    // Hooks
    useEffect(() => {
        if (resetThisFilter && isDirty) {
            setValue('');
            setIsDirty(false);
        }
    }, [resetThisFilter]);


    const onChange = (selectedValue) => {
        setIsDirty(true);
        setValue(selectedValue);
        addFilter(columnId, selectedValue);
        setLaunchSearch(true);
    };

    return (
        <>
            <SelectInput
                selectId='select-filter-value'
                options={options}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                namespace={namespace}
                autoFocus={true}
                sortOptions={sortOptions}
            />
        </>
    );
}

export default SelectFilter;

SelectFilter.propTypes = {
    addFilter: PropTypes.func.isRequired,
    columnId: PropTypes.string.isRequired,
    defaultValue: PropTypes.any,
    values: PropTypes.array.isRequired,
    resetThisFilter: PropTypes.bool,
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    namespace: PropTypes.string,
    setLaunchSearch: PropTypes.func.isRequired,
    sortOptions: PropTypes.bool
};